import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import {i18n} from '@/i18n';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper);

// vuex
import store from './store'; // 修改为相对路径
Vue.prototype.$store = store

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'

Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    //完全显示的时候加载
    preLoad: 1,
    //失败时显示的图片
    error: require('./assets/img/error.png'),
    //加载时显示的GIF图
    loading: require('./assets/img/loading.gif'),
    //尝试加载几次
    attempt: 1
});

// 注册组件
// 注册组件
import cover from "./components/cover/cover.vue";
Vue.component('cover', cover);

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 5000
//设置api地址
//全局定义axios
axios.defaults.baseURL = 'http://shkjgw.shkjem.com/api/'
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'

new Vue({
    store, // 将 store 注入到 Vue 实例中
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
